import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

/**
 * Título de la pantalla que pinta el header del shell (kicker + título).
 *
 * Por defecto se deriva de la ruta (nav.js → pageMetaFor). Las pantallas con
 * título dinámico —la ficha de un prospecto, la edición de una empresa— lo
 * sobrescriben con usePageTitle(); al desmontarse, el shell vuelve al valor
 * derivado de la ruta.
 */
const PageTitleContext = createContext({ override: null, setOverride: () => {} });

export const PageTitleProvider = ({ children }) => {
  const [override, setOverride] = useState(null);
  const value = useMemo(() => ({ override, setOverride }), [override]);
  return <PageTitleContext.Provider value={value}>{children}</PageTitleContext.Provider>;
};

export const usePageTitleValue = () => useContext(PageTitleContext).override;

/**
 * Sobrescribe el título mientras la pantalla está montada.
 *   usePageTitle({ kicker: 'Plataforma', title: company?.name });
 * Pasar null/undefined en `title` deja el título derivado de la ruta.
 */
export function usePageTitle({ kicker, title } = {}) {
  const { setOverride } = useContext(PageTitleContext);
  useEffect(() => {
    if (!title) return undefined;
    setOverride({ kicker, title });
    return () => setOverride(null);
  }, [kicker, title, setOverride]);
}

export default PageTitleContext;
